export default __webpack_public_path__ + "static/media/error_bot.00d43417.jpg";